import EmailForm from '../../components/Emails/EmailForm';
import { UPDATE_EMAIL } from '../../constants';

function EmailEdit() {
  return <EmailForm type={UPDATE_EMAIL} />;
}

export default EmailEdit;
